import {dateSort, firstFilter, lastFilter} from '../Report/helperfunctions'
import {isRepeaterRadio} from '../Report/Model/DeviceType'
import { isIgnored } from '../Report/Consumption';

export function filterSensors (arrData) {
  const retcode = arrData.filter(reading => 
    !(reading.DeviceId.toUpperCase().startsWith ("E") ||
      reading.DeviceId.toUpperCase().startsWith ("F") ||
      reading.DeviceId.startsWith("1"))
  )
  return retcode;
}
export function filterRepeaters (arrData) {
  return (
    arrData.filter(reading => isRepeaterRadio (reading, 'DeviceId'))
  )
}
export function filterConnected (arrData) {
  const unique = [...new Set(arrData.map(item => item.DeviceId))];
  return unique;
}

export function filterAdvancing(arrData) {
  const arrReadings = dateSort(arrData, 'ReadTime');
  const keyProp = 'DeviceId';
  const newest = firstFilter (arrReadings, keyProp);
  const oldest = lastFilter (arrReadings, keyProp);
  const result = newest.filter(item =>
    (!isIgnored(item.SensorType1) && item.ReadVal1 !== oldest.find(eldest => eldest.DeviceId === item.DeviceId).ReadVal1) ||
    (!isIgnored(item.SensorType2) && item.ReadVal2 !== oldest.find(eldest => eldest.DeviceId === item.DeviceId).ReadVal2)
  )
  return result;
}

